import React, { Component } from 'react'
import './TravelBanner.css'

export default class TravelBanner extends Component {
    render() {
        return (
            <div>
                <img className='TravelBanner' src='images/SafeTravels.jpg' alt='Safe Travel Poster Banner' />
            </div>
        )
    }
}
